import { ref } from "vue";

/**
 * Composable for handling absence updates
 */
export function useAbsenceUpdates() {
  /**
   * Updates absences data and triggers update notification
   */
  const updateAbsences = (date?: Date) => {
    if (date) {
      absencesUpdated.value = date;
    }
  };

  /**
   * Property to track if absences were updated
   * Only changes when updateAbsences is called with a date
   */
  const absencesUpdated = ref<Date | null>(null);

  return {
    updateAbsences,
    absencesUpdated
  };
}
